module.exports = __webpack_public_path__ + "ec7f73496c66d29680ef57bf9e2f5b9f.MP3";